import { AspectRatio } from '@chakra-ui/react';
import Steps from '@components/interactive/Steps';
import DefaultLayout from '@components/layout/layout/DefaultLayout';

import cluster from '@public/flaticons/clusters/stop-spam-hero.png';
import envelope from '@public/flaticons/envelope.png';
import spam from '@public/flaticons/spam.png';
import telephone from '@public/flaticons/telephone.png';
import { TypeformLinks } from '@utils/index';
import { FsmColors } from 'chakra-ui/fsmTheme';
import Image, { StaticImageData } from 'next/image';
import { CtaTypes } from '../common/CTA';
import ProductHero from '../common/ProductHero';

const steps = [
  {
    header: 'Stop the calls',
    description:
      'We enter your phone number and email into the Federal Government’s “Do Not Call Registry.” You click “Confirm” on an email from the government, and you’re all set.',
    bg: FsmColors.blue,
    image: telephone,
    alt: 'Spam Calls Graphic',
  },
  {
    header: 'Stop non-financial junk mail',
    description:
      'We enter your name, address, and email address into the “Do Not Mail” list run by the Direct Marketing Association. They charge $4 to add you to the list and keep you on it for ten years.',
    bg: FsmColors.teal,
    image: spam,
    alt: 'Junk Mail Graphic',
  },
  {
    header: 'Stop financial junk mail',
    description:
      'There’s a special form you need to fill out to stop receiving offers for credit cards and insurance products. Since it requires your social security number, we’ll email you a link to the form instead of filling it out for you.',
    bg: FsmColors.navy,
    image: envelope,
    alt: 'Financial Mail Graphic',
  },
];

const renderImage = (image: StaticImageData, alt: string) => (
  <AspectRatio ratio={1} width={['140px', '140px', '200px']}>
    <Image src={image} alt={alt} fill />
  </AspectRatio>
);

const StopSpam = () => {
  const typeformLink = TypeformLinks.stopSpam;
  const header = 'Stop spam calls and junk mail';
  const subheader = `In a few clicks, we'll add your name to the national "Do Not Call" and "Do Not Mail" lists.`;
  const imageAlt = 'Stop Spam Hero';
  const buttonText = 'Get Started';

  return (
    <DefaultLayout>
      <ProductHero
        header={header}
        subheader={subheader}
        imageSrc={cluster}
        imageAlt={imageAlt}
        ctaType={CtaTypes.button}
        buttonText={buttonText}
        href={typeformLink}
        showPeriod
      />
      {steps && <Steps data={steps} renderImage={renderImage} />}
      <ProductHero
        header={header}
        subheader={subheader}
        ctaType={CtaTypes.button}
        buttonText={buttonText}
        href={typeformLink}
        showPeriod
      />
    </DefaultLayout>
  );
};

export default StopSpam;
